var questionnaire = {
    accountCredits: 'Account Credits',
    characterCountHelpText: '{{charactersRemaining}} characters remaining',
    creditAmount: 'Credit Amount',
    creditIssued: 'Credit Issued',
    description: 'Description',
    doYouWantToRedispute: 'Do you want to redispute this transaction?',
    foundRecentCredits: 'We found recent account credits listed below that may be related to this transaction.',
    helpUsLearnMore: 'Help us learn more',
    ifSoWeWillReevaluate: "If so, we'll re-evaluate the case details and any supporting evidence you previously provided or any new supporting evidence you provide us. It can take up to 60 days to complete our review of the redisputed case. You're not responsible for the disputed amount while our review is underway, but you do need to make the minimum payment for any non-disputed balance by the due date.",
    notEligible: 'This transaction is not eligible to be redisputed online',
    noTransactionsFound: 'No transactions found',
    oneCharacterCountHelpText: '1 character remaining',
    originalTransaction: 'Original Transaction:',
    pending: 'Pending',
    pendingCreditsNote: '<0>Note</0>: Pending credits will typically post to your account within 48 hours. Credits will be reflected online within 3 days and your billing statement within 1–2 billing cycles. If they haven’t posted, please contact us via Online Chat.',
    pleaseTryAgain: 'Please contact us using <0>Online Chat</0> for assistance.',
    pleaseUseOnlineChat: 'If you have any more questions about this transaction, please use our <0>Online Chat.</0>',
    toGetNotified: 'To get notified of credits posted to your account, <0>sign up</0> to get alerts.',
    posted: 'Posted',
    purchase: 'Purchase',
    recentAccountCredits: 'Recent Account Credits',
    reminder: 'Please only use letters, numbers and these supported characters: {{specialCharacters}}',
    securityDisclaimerHelpNote: "You'll have a chance to upload supporting documents you'd like to share after you submit this dispute.",
    securityDisclaimerNoteTitle: 'Note:',
    securityDisclaimerReminder: "For your security, please don't enter personal information (e.g. Social security number, credit card number and/or protected health information).",
    securityDisclaimerReminderTitle: 'Reminder:',
    stillWantToDispute: 'Do you still want to dispute it?',
    wontOpenDispute: "Since these credit(s) resolved your problem, we won't open a dispute for this transaction.",
    youCanHelpUs: 'You can help us better understand your dispute by answering some questions. Your responses are important—please take a few minutes to complete this step.',
    recurringTransactionHelperText: 'If you need to add recurring transactions older than 6 months, please contact us through <0>Online Chat.</0>',
    transactionDate: 'Date',
    transactionDescription: 'Description',
    transactionAmount: 'Amount',
    referenceNumber: 'Reference Number',
    purchaseLocation: 'Purchase Location',
    address: 'Address',
    continue: 'Continue'
};
export default questionnaire;
//# sourceMappingURL=questionnaire.js.map